import React, { FC } from 'react';
import Grid from '@mui/material/Grid';
import { FIELDS, immutableFields } from './reducer';
import { WBFormField } from '@wealthberry/common-base/src/forms/field';
import InputAdornment from '@mui/material/InputAdornment';
import { formatCurrencySymbol } from '@wealthberry/common-base/src/utils';
import { WBFilterDialogWrapper } from '@wealthberry/common-base/src/components/wb-list/wb-filter-dialog';

type Props = {
    toggle: () => void,
    open: boolean;
    dispatch: any;
    form: any;
    formInitial: any;
}

const END_ADORNMENT = {
    [FIELDS.AMOUNT_TO]: (
        <InputAdornment position="end">
            {formatCurrencySymbol()}
        </InputAdornment>
    ),
    [FIELDS.AMOUNT_FROM]: (
        <InputAdornment position="end">
            {formatCurrencySymbol()}
        </InputAdornment>
    )
}

export const FilterDialog: FC<Props> = ({ toggle, open, form, dispatch, formInitial }) => {
    return (
        <WBFilterDialogWrapper
            title="translate.filter.dialog.deposit.transactions"
            toggle={toggle}
            open={open}
            form={form}
            dispatch={dispatch}
            formInitial={formInitial}
        >
            <Grid container spacing={3}>
                {Object.keys(form.dialog).map((key) => (
                    <WBFormField
                        key={key}
                        {...form.dialog[key]}
                        _fieldInfo={{
                            ...immutableFields[key],
                            InputProps: {
                                endAdornment: END_ADORNMENT[key]
                            }
                        }}
                        setState={(updatedField) =>
                            dispatch({
                                type: 'UPDATE_FORM',
                                payload: {
                                    dialog: {
                                        [key]: updatedField,
                                    }
                                }
                            })
                        }
                        validations={[]}
                    />
                ))}
            </Grid>
        </WBFilterDialogWrapper>
    );
};

